export default {"src":"/_next/static/media/mastercard.9d810405.svg","height":20,"width":25,"blurWidth":0,"blurHeight":0};